module.exports = __webpack_public_path__ + "static/logos-tiles-lam-1a1416c452179c39ce8cbe4889f7109f.svg";